<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <v-card>

          <v-card-title>
            <v-row>
              <v-col cols="4" md="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search By Outturn" single-line hide-details></v-text-field>
              </v-col>
              <v-col cols="8" class="text-right">
                <h4> {{ records[0]?.documentUpload?.fileName }}</h4>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table :loading="loading" v-model="selected" :headers="computedHeaders" :items="records"
                          item-key="id" show-select class="elevation-1" :search="search" :single-select="singleSelect">
              <template v-slot:top v-if="hasCanBeApprovedData(records) && $can('CAN_INITATE_WARRANT_COLLECTION')">
                <!-- <v-btn class="mr-2" @click="confirmDriverAction('APPROVE_SELECTED')" color="primary">Initiate Collection</v-btn> -->
                <v-btn class="mr-2" @click="confirmDriverAction('APPROVE_SELECTED')"
                       color="primary" :disabled="submitting">
                  <v-progress-circular v-if="submitting" indeterminate size="20"></v-progress-circular>
                  <span v-else>Initiate Collection</span>
                </v-btn>
                <!-- <v-btn class="ml-2" @click="confirmAction('REJECT_SELECTED')" color="warning">Reject Selected</v-btn> -->
                <!-- <v-btn class="ml-2" @click="confirmAction('APPROVE_ALL')" color="warning">Approve All</v-btn>
                <v-btn class="ml-2" @click="confirmAction('REJECT_ALL')" color="warning">Reject All</v-btn> -->
              </template>
              <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
                <v-simple-checkbox :ripple="false" color="green" :value="isSelected"
                                   @input="select($event)" v-if="!$can('CAN_INITATE_WARRANT_COLLECTION')" disabled class="d-none">
                </v-simple-checkbox>
                <v-simple-checkbox :ripple="false" color="green" :value="isSelected" v-else @input="select($event)">
                </v-simple-checkbox>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on" text icon class="actions">
                      <v-icon class="secondary--text"> more_horiz</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="$can('CAN_APPROVE_GRN') && hasGrnStatusIdData(item) || $can('CAN_UPLOAD_GRN') && hasGrnApproveMillerData(item)"
                                 @click="showEditDialog(item,'edit')">
                      <v-list-item-title> Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="$can('CAN_UPLOAD_GRN') && hasGrnApproveMillerData(item) || $can('CAN_APPROVE_GRN') && hasGrnApproveWarehouseData(item)"
                                 @click="showEditDialog(item,'approve')">
                      <v-list-item-title> Approve</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:item.dateUpdated="{ item }">
                {{ item.dateUpdated | prettyDate }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">Records</v-card-title>
        <v-card-text class="primary--text">
          {{ confirmMessage }}
          {{ this.action }}
          <v-text-field name="comment" label="Comment" v-model="approverComment" :rules="commentRules" required></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="confirmDialog = false" class="font-weight-bold">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" class="accent--text logoutbtn" @click="approveRecords(action)">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="initiateCollectionsDialog" max-width="900px" persistent  >
      <v-card>
        <!-- Title -->
        <v-card-title class="headline font-weight-bold">
          Create Collection
          <v-spacer></v-spacer>
          <v-btn icon @click="initiateCollectionsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" lazy-validation>
          <!-- Tabs -->
          <v-tabs v-model="initiateCollectionsTab" background-color="white" grow>
            <v-tab>Driver checkoffSettlementDetails</v-tab>
            <v-tab>Vehicle checkoffSettlementDetails</v-tab>
          </v-tabs>

          <v-tabs-items v-model="initiateCollectionsTab">
            <!-- Driver Details Tab -->
            <v-tab-item>
              <v-card-text>
                <v-container>
                  <v-row>
                    <!-- Left Form -->
                    <v-col cols="7">
                      <v-text-field
                        label="Search driver by id"
                        v-model="idNumber"
                        required
                        :rules="[rules.noSpecialChars]"
                        append-icon="mdi-magnify"
                      ></v-text-field>
                      <v-btn color="green darken-1" dark small @click="getDriverDetails">
                        Search
                        <v-progress-circular color="white" v-if="searchDriverLoader" indeterminate size="20"></v-progress-circular>
                      </v-btn>

                      <v-row>
                        <v-col cols="6">
                          <v-text-field label="First Name"
                                        v-model="driver_info.firstName"
                                        required
                                        :rules="[rules.required,rules.onlyLetters]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="Last Name"
                                        v-model="driver_info.lastName"
                                        required
                                        :rules="[rules.required,rules.onlyLetters]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="Email"
                                        v-model="driver_info.email"
                                        required
                                        :rules="[rules.required,rules.email]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="ID Number"
                                        v-model="driver_info.idNumber"
                                        required
                                        :rules="[rules.required,rules.noSpecialChars]"></v-text-field>
                        </v-col>
                      </v-row>

                      <v-btn color="green darken-1" dark @click="addNewDriver">
                        Add New Driver
                      </v-btn>
                    </v-col>

                    <!-- Right Driver List -->
                    <v-col cols="5">
                      <v-list two-line>
                        <v-list-item
                          v-for="(d, i) in drivers"
                          :key="i"
                        >
                          <v-list-item-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{ d.firstName }}</v-list-item-title>
                            <v-list-item-subtitle>{{ d.idNumber }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click="removeDriver(i)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-tab-item>

            <!-- Vehicle Details Tab -->
            <v-tab-item>
              <v-card-text>
                <v-container>
                  <v-row>
                    <!-- Left Form -->
                    <v-col cols="7">
                      <v-text-field
                        label="Search vehicle by registration"
                        v-model="registrationNumber"
                        required
                        :rules="[rules.noSpecialChars]"
                        append-icon="mdi-magnify"
                      ></v-text-field>
                      <v-btn color="green darken-1" dark small @click="getVehicleDetails">
                        Search
                        <v-progress-circular color="white" v-if="searchVehicleLoader" indeterminate size="20"></v-progress-circular>
                      </v-btn>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field label="Registration Number"
                                        v-model="vehicle_info.regNumber"
                                        required
                                        :rules="[rules.required,rules.noSpecialChars]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="Type"
                                        v-model="vehicle_info.type"
                                        required
                                        :rules="[rules.required,rules.noSpecialChars]"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="Vehicle Description"
                                        v-model="vehicle_info.description"
                                        required
                                        :rules="[rules.required,rules.noSpecialChars]"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                        </v-col>
                      </v-row>

                      <v-btn color="green darken-1" dark @click="addNewVehicle">
                        Add New Vehicle
                      </v-btn>
                    </v-col>

                    <!-- Right Driver List -->
                    <v-col cols="5">
                      <v-list two-line>
                        <v-list-item
                          v-for="(d, i) in vehicles"
                          :key="i"
                        >
                          <v-list-item-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{ d.regNumber }}</v-list-item-title>
                            <v-list-item-subtitle>{{ d.type }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click="removeVehicle(i)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>

          <!-- Footer -->
          <v-card-actions>
            <v-menu
              v-model="datePickerMenu"
              ref="datePickerMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="collectionDate"
                  label="Collection Date"
                  :rules="[rules.required]"

                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="collectionDate"
                @input="datePickerMenu = false"
                :min="today"
              ></v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" dark @click="markWarrant()">
              Initiate collection
              <v-progress-circular color="white" v-if="initiateCollectionsLoader" indeterminate size="20"></v-progress-circular>

            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- create driver checkoffSettlementDetails -->
    <v-dialog v-model="createDriverDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Create Collection Details</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" lazy-validation>
              <v-layout wrap>
                <!-- Driver Details Title -->
                <v-flex xs12>
                  <v-subheader class="text-h6 my-4 text-center">Driver Details</v-subheader>
                </v-flex>
                <!-- Driver Details Section -->
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="idNumber"
                    label="ID Number *"
                    required
                    :rules="[rules.noSpecialChars]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="getDriverDetails" medium>
                    <v-icon>search</v-icon> Search
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="driver.firstName"
                    label="Firstname"
                    required
                    :rules="[rules.required,rules.onlyLetters]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="driver.lastName"
                    label="Lastname"
                    required
                    :rules="[rules.required,rules.onlyLetters]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="driver.email"
                    label="Email"
                    required
                    :rules="[rules.required,rules.email]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="driver.idNumber"
                    label="ID Number"
                    required
                    :rules="[rules.required,rules.noSpecialChars]"
                  ></v-text-field>
                </v-flex>

                <!-- Vehicle Details Title -->
                <v-flex xs12>
                  <v-subheader class="text-h6 my-4 text-center">Vehicle Details</v-subheader>
                </v-flex>

                <!-- Vehicle Details Section -->
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="driver.registrationNumber"
                    label="Registration Number"
                    required
                    :rules="[rules.required,rules.noSpecialChars]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="driver.vehicleType"
                    label="Type"
                    required
                    :rules="[rules.required,rules.noSpecialChars]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="driver.vehicleDescription"
                    label="Vehicle Description"
                    required
                    :rules="[rules.required,rules.noSpecialChars]"
                  ></v-text-field>
                </v-flex>
                <v-menu
                  v-model="datePickerMenu"
                  ref="datePickerMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="driver.dateOfBirth"
                      label="Collection Date"
                      :rules="[rules.required]"

                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="driver.dateOfBirth"
                    @input="datePickerMenu = false"
                    :min="today"
                  ></v-date-picker>
                </v-menu>

              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="createDriverDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="markWarrant()" :disabled="submitting">
            <v-progress-circular v-if="submitting" indeterminate size="20"></v-progress-circular>
            <span v-else>Submit</span>
          </v-btn>
          <!-- <v-btn color="primary" @click="markWarrant()">Submit</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline accent--text">{{ action }} GRN Record</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.outTurnNumber" label="OutTurn" v-bind:readonly="approve"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.bags" label="Bags" required v-bind:readonly="approve"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.pockets" label="Pockets" required v-bind:readonly="approve"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.grossWeight" label="Gross W" required v-bind:readonly="approve"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.tareWeight" label="Tare W" required v-bind:readonly="approve"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.netWeight" label="Net W" required v-bind:readonly="approve"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions v-if="approve">
          <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="editDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerApproveRecord">Approve</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="editDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerEditRecord">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
export default {
	data () {
		return {
			initiateCollectionsTab: 0,
			searchId: '',
			collectionDate: '',
			snackbar: false,
			searchDriverLoader: false,
			searchVehicleLoader: false,
			initiateCollectionsLoader: false,
			snackbarColor: '',
			initiateCollectionsDialog: false,
			driver_info: {
				idNumber: '',
				firstName: '',
				middleName: '',
				lastName: '',
				email: '',
				dob: new Date(),
				lastUpdateDate: new Date(),
				creationDate: new Date(),
				registrationNumber: '',
				vehicleType: '',
				vehicleDescription: ''
			},
			vehicle_info: {
				regNumber: '',
				type: '',
				description: ''
			},
			drivers: [
			],
			vehicles: [
			],
			submitting: false, // Track submission state
			search: '', // Define search property to bind with v-text-field
			records: [], // Ensure records is defined
			selected: [],
			loading: false,
			singleSelect: false,
			confirmDialog: false,
			createDriverDialog: false,
			confirmMessage: '',
			approverComment: '',
			commentRules: [(v) => !!v || 'Comment is required'],
			editDialog: false,
			action: '',
			grnRecord: {},
			valid: false,
			approve: false,
			paginationOptions: {
				page: 1,
				itemsPerPage: 10
			},
			totalRecords: 0, // Total items for pagination
			rules: {
				required: value => !!value || 'This field is required.',
				noSpecialChars: v => /^[a-zA-Z0-9\s]*$/.test(v) || 'No special characters allowed',
				onlyLetters: v => /^[a-zA-Z\s]*$/.test(v) || 'Only letters and spaces are allowed',

				email: v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
			},
			idNumber: '',
			registrationNumber: '',
			datePickerMenu: false,
			today: new Date().toISOString().substr(0, 10),
			driver: {
				idNumber: '',
				firstName: '',
				lastName: '',
				email: '',
				dob: new Date(),
				lastUpdateDate: new Date(),
				creationDate: new Date(),
				registrationNumber: '',
				vehicleType: '',
				vehicleDescription: ''
			}
		}
	},
	computed: {
		computedHeaders () {
			return [

				{ text: 'OutturnNumber', value: 'outTurn' },
				{ text: 'Mark', value: 'marks' },
				{ text: 'Grade', value: 'grade' },
				{ text: 'WarrantNumber', value: 'warrantNumber' },
				{ text: 'Season', value: 'season' },
				{ text: 'Sale', value: 'saleNumber' },
				{ text: 'Number Of Bags', value: 'numberOfBags' },
				{ text: 'Number Of Pockets', value: 'numberOfPocket' },
				{ text: 'Total Weight', value: 'weight' },
				{ text: 'Marketer', value: 'marketerName' },
				{ text: 'Status', value: 'status.statusName' },
				{ text: 'Date', value: 'dateUpdated' }

			]
		}
	},
	methods: {
		addDriverById () {
			if (this.searchId) {
				this.drivers.push({ name: this.searchId, id: '2495892' })
				this.searchId = ''
			}
		},
		addNewDriver () {
			const newDriver = {
				idNumber: this.driver_info.idNumber,
				firstName: this.driver_info.firstName,
				middleName: '',
				lastName: this.driver_info.lastName,
				email: this.driver_info.email,
				dob: new Date()
			}
			this.drivers.push(newDriver)
			this.driver_info = {
				idNumber: '',
				firstName: '',
				lastName: '',
				email: '',
				dob: new Date(),
				lastUpdateDate: new Date(),
				creationDate: new Date()
			}
		},
		addNewVehicle () {
			const newVehicle = {
				regNumber: this.vehicle_info.regNumber,
				type: this.vehicle_info.type,
				description: this.vehicle_info.description
			}
			this.vehicles.push(newVehicle)
			this.vehicle_info = {
				regNumber: '',
				type: '',
				description: ''
			}
		},
		removeDriver (index) {
			this.drivers.splice(index, 1)
		},
		removeVehicle (index) {
			this.vehicles.splice(index, 1)
		},
		initiateCollection () {
			alert('Collection initiated!')
		},
		getDriverDetails () {
			this.searchDriverLoader = true
			const url = config.serverURI + '/driver/validate?idNumber=' + this.idNumber
			axios.post(url)
				.then(response => {
					this.searchDriverLoader = false
					this.driver = response.data
					this.driver_info = response.data
					this.idNumber = ''
					// this.totalAmount();

					// Assuming there's another API endpoint to fetch eslip checkoffSettlementDetails
				})
				.catch(error => {
					this.searchDriverLoader = false
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		getVehicleDetails () {
			this.searchVehicleLoader = true
			const url = config.serverURI + '/vehicle/validate?regNumber=' + this.registrationNumber
			axios.post(url)
				.then(response => {
					this.searchVehicleLoader = false
					const keyMap = {
						registrationNumber: 'regNumber',
						vehicleType: 'type',
						vehicleDescription: 'description'
					}

					// rename keys to accommodate the vehicle_info keys
					const vehicle = this.renameKeys(response.data, keyMap)
					this.vehicle_info = vehicle
					this.registrationNumber = ''
				})
				.catch(error => {
					this.searchVehicleLoader = false
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},

		markWarrant () {
			const form = this.$refs.form
			// if (!form.validate()) {
			// // if (!form.validate()) {
			// 	// If validation fails, Vuetify will highlight invalid fields
			// 	this.initiateCollectionsDialog = false
			// 	this.snackbar = true
			// 	this.snackbarColor = 'error'
			// 	this.message = 'Please fill out all required fields.'
			// 	return
			// }

			if (this.selected.length === 0) {
				this.initiateCollectionsDialog = false
				this.snackbar = true
				this.snackbarColor = 'error'
				this.message = 'Please select outturn'
				return
			}

			if (this.drivers.length === 0 && this.vehicles.length === 0) {
				this.initiateCollectionsDialog = false
				this.snackbar = true
				this.snackbarColor = 'error'
				this.message = 'Please enter driver/vehicle checkoffSettlementDetails'
				return
			}
			const idNumber = this.driver.idNumber
			const email = this.driver.email

			const firstName = this.driver.firstName
			const lastName = this.driver.lastName
			const dob = this.driver.dob
			const registrationNumber = this.driver.registrationNumber
			const vehicleDescription = this.driver.vehicleDescription
			const vehicleType = this.driver.vehicleType

			console.log('Driver checkoffSettlementDetails',
				idNumber,
				email,
				firstName,
				lastName,
				dob,
				registrationNumber,
				vehicleDescription,
				vehicleType
			)
			this.processingRequest = true
			this.showProgressBar = true
			this.submitting = true // Start loader
			const url = `${config.serverURI}/warrant/markcollected`

			const ids = this.selected.map((item) => item.id)

			const payload = {
				ids: ids, // put your collection IDs here
				// ids: [703, 704], // put your collection IDs here
				driverCollectionDetails: this.drivers.map(d => ({
					idNumber: d.idNumber,
					firstName: d.firstName,
					lastName: d.lastName,
					email: d.email
				})),
				vehicleCollectionDetails: this.vehicles.map(v => ({
					registrationNumber: v.regNumber,
					vehicleType: v.type,
					vehicleDescription: v.description
				})),
				collectionDate: this.collectionDate
			}

			// console.log("Selected item", selectedIds);

			this.createDriverDetailsLoader = true
			// this.createDriverDialog = false

			this.initiateCollectionsLoader = true
			// axios.post(url, this.selected)
			axios
				.post(url, payload)

				.then((response) => {
					this.initiateCollectionsLoader = false
					this.initiateCollectionsDialog = false
					this.snackbar = true
					this.createDriverDetailsLoader = false
					this.message = response.data.message
					this.snackbarColor = response.data.error ? 'error' : 'primary'
					this.selected = []
					this.driver = {}
					this.driver_info = {}
					this.vehicle_info = {}
					this.drivers.length = 0
					this.vehicles.length = 0
				})
				.catch((error) => {
					this.message = error.response ? error.response.status : 'Error'
					this.snackbarColor = 'error'
					this.snackbar = true
					this.driver = {}
				})
				.finally(() => {
					this.submitting = false // Start loader
					this.driver = {}

					this.showProgressBar = false
					this.processingRequest = false
					this.getDataFromApi()
				})
		},

		getDataFromApi () {
			this.loading = true
			const { page, itemsPerPage } = this.paginationOptions // Correct variable usage

			const url = `${config.serverURI}/warrant/uncollected?page=${page - 1}&size=${itemsPerPage}` // Page is usually 0-based
			axios
				.get(url)
				.then((response) => {
					const data = response.data

					this.records = data.content // Ensure API returns paginated data in `content`
					this.totalRecords = data.page.totalElements // Assign total number of records, not pages

					console.log('Fetched warrants:', this.records)
				})
				.catch((error) => {
					this.message = error.response ? error.response.status : 'Error'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
				.finally(() => {
					this.loading = false
				})
		},

		handleChange () {
			// Update deleteFlag to true if the checkbox is checked
			this.grnRecord.deleteFlag = true
		},

		confirmAction (action) {
			this.action = action
			this.confirmDialog = true
			this.recordsToApprove = this.action.includes('SELECTED') ? this.selected.filter(record => record.status)
				: this.records.filter(record => record.status)
			this.confirmMessage = action + ' - ' + this.recordsToApprove.length + ' records'
		},
		confirmDriverAction (action) {
			this.action = action
			// this.createDriverDialog = true
			this.initiateCollectionsDialog = true
			//   this.recordsToApprove = this.action.includes('SELECTED') ? this.selected.filter(record => record.status)
			//       : this.records.filter(record => record.status)
			//   this.confirmMessage = action + ' - ' + this.recordsToApprove.length + ' records'
		},
		hasGrnStatusIdData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'HOLDING_STATUS' || item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL' ||
        item.status.statusName === 'PENDING_APPROVAL'
			)
			// return this.records.filter(item => item.status !== null);
		},

		hasGrnApproveWarehouseData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL')
		},

		hasGrnApproveMillerData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'REFERRED_TO_MILLER')
			// return this.records.filter(item => item.status !== null);
		},

		hasCanBeApprovedData (records) {
			return records.length > 0
			// && records.some(record => record.status && (record.status.statusName === 'PENDING_APPROVAL'))
		},

		hasGrnStatus () {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return this.records.filter(item => item.status !== null)
		},
		showEditDialog (item, type) {
			this.grnRecord = item
			this.editDialog = true
			this.action = type
			if (type !== 'edit') {
				this.approve = true
			}
		},

		approveRecords () {
			console.log('Action:', this.action)

			if (this.recordsToApprove.length === 0) {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: 'No record selected for action ' + this.action
				})
				return
			}

			const recordData = {
				action: this.action,
				comment: this.approverComment,
				records: this.recordsToApprove
			}

			this.loading = true // Optional: Show loading state

			axios
				.post(`${config.serverURI}/warrant/approvePendingCollection`, recordData)
				.then((response) => {
					if (response.data.error === false) {
						this.$store.dispatch('alert/displayAlert', {
							snackbar: true,
							color: 'primary',
							message: response.data.message
						})
					} else {
						this.$store.dispatch('alert/displayAlert', {
							snackbar: true,
							color: 'error',
							message: response.data.message
						})
					}

					// this.$store.dispatch("grnfile/viewFile", this.$route.params.id);
					this.getDataFromApi()
					this.selected = []
					this.confirmDialog = false
					this.recordsToApprove = []
					this.approverComment = ''
					this.confirmMessage = ''
				})
				.catch((error) => {
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response?.data?.message || 'Error occurred'
					})
				})
				.finally(() => {
					this.loading = false // Optional: Hide loading state
				})
		},
		triggerEditRecord () {
			this.editRecord(this.grnRecord).then(response => {
				if (response.data.error === false) {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
				} else {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
				}
				this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
				this.selected = []
				this.editDialog = false
			}).catch(error => {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: error.response.data ? error.response.data.message : 'Error ocurred'
				})
				this.editDialog = false
			})
		},
		triggerApproveRecord () {
			// this.millerApproveRecord(this.grnRecord).then(response => {
			this.editRecord(this.grnRecord).then(response => {
				if (response.data.error === false) {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
				} else {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
				}
				this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
				this.selected = []
				this.editDialog = false
			}).catch(error => {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: error.response.data ? error.response.data.message : 'Error ocurred'
				})
				this.editDialog = false
			})
		},
		renameKeys (obj, keyMap) {
			return Object.keys(obj).reduce((acc, key) => {
				const newKey = keyMap[key] || key // use mapped key if available
				acc[newKey] = obj[key]
				return acc
			}, {})
		}
	},
	mounted () {
		this.getDataFromApi() // Fetch data on component mount
	}
}
</script>

<style>
</style>
